import axios from 'axios';
import { getIndexedDB, removeItemIndexdDB } from './indexed-DB/indexedDB';
import router from '@/router';
axios.defaults.baseURL = 'https://api.keshik6.ir'
export const StorageUrl = 'https://api.keshik6.ir/storage/uploads/' 
interface TypeHttpRequest {
    url: string
    data?: any
    config?: any
}
export async function HttpRequestAxios({ url, data, config }: TypeHttpRequest) {
    const token = await getIndexedDB('token')
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    if (data && config) {
        return await axios.post(url, data, config)
            .then(res => res.data)
            .catch(err => {
                if (err.response.status == 401) {
                    router.push('/auth')                   
                    removeItemIndexdDB('token')
                    removeItemIndexdDB('profile')
                } else {
                    return err.response
                }
            })
    } else if (config) {
        return await axios.post(url, config)
            .then(res => res.data)
            .catch(err => {
                if (err.response.status == 401) {
                    router.push('/auth')
                    removeItemIndexdDB('token')
                    removeItemIndexdDB('profile')
                } else {
                    return err.response
                }
            })
    }
    else if (data) {
        return await axios.post(url, data)
            .then(res => res.data)
            .catch(err => {
                if (err.response.status == 401) {
                    router.push('/auth')
                    removeItemIndexdDB('token')
                    removeItemIndexdDB('profile')
                } else {
                    return err.response
                }
            })
    } else {
        return await axios.post(url)
            .then(res => res.data)
            .catch(err => {
                if (err.response.status == 401) {
                    router.push('/auth')
                    removeItemIndexdDB('token')
                    removeItemIndexdDB('profile')
                } else {
                    return err.response
                }
            })
    }

}